import network from '@/services/network';

/**
 * Admin-editierbare Texte der generierten Antrags-Schreiben (BER-67,
 * 10.09.2026): Zuzahlungs-Schreiben + Bestätigung des gesetzlichen
 * Vertreters. Nur mit `application-templates.manage` (gleicher Admin-Bereich
 * wie die Antragsvorlagen).
 */

/** Ein Schreiben: effektiver Stand (DB-Wert, sonst Code-Vorgabe) + Meta. */
export interface DokumentText {
  key: string;
  name: string;
  beschreibung: string;
  /** Verfügbare Platzhalter, z. B. „{vn_name}" (Anzeige-Hinweis). */
  platzhalter: string[];
  /** Hat der Text eine eigene Mehrzahl-Variante (Vertreter: mehrere Kinder)? */
  hat_mehrzahl: boolean;
  titel: string | null;
  text: string;
  text_mehrzahl: string | null;
}

const list = async (): Promise<DokumentText[]> => {
  const { data } = await network.get<{ data: DokumentText[] }>('/dokument-texte');
  return data.data;
};

const save = async (eintrag: {
  key: string;
  titel: string | null;
  text: string;
  text_mehrzahl: string | null;
}): Promise<void> => {
  await network.put('/dokument-texte', eintrag);
};

const dokumentTexte = { list, save };

export default dokumentTexte;
